import React, { useRef } from "react";
import PropTypes from "prop-types";
import helpers from "helpers/base";
import classnames from "classnames";

const Checkbox = ({
  checked = false,
  disabled = false,
  label = null,
  name,
  noLabel = false,
  onChange,
  value = "selected",
  containerClass,
  id,
  children
}) => {
  const inputIdRef = useRef(id || helpers.generateComponentUuid("checkbox"));

  const renderLabel = () => {
    if (noLabel) {
      return null;
    }

    return (
      <label className="lc-checkbox__label" htmlFor={inputIdRef.current}>
        {label || children}
      </label>
    );
  };

  return (
    <div className={classnames("lc-checkbox", containerClass)}>
      <input
        className="lc-checkbox__input"
        defaultChecked={checked}
        disabled={disabled}
        id={inputIdRef.current}
        name={name}
        onChange={onChange}
        type="checkbox"
        value={value}
      />
      {renderLabel()}
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  containerClass: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  noLabel: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string
};

Checkbox.defaultProps = {
  checked: false,
  children: null,
  containerClass: null,
  disabled: false,
  id: null,
  label: null,
  noLabel: false,
  onChange: null,
  value: "selected"
};

export default Checkbox;
